import React from 'react'
import * as PropTypes from 'prop-types'

import { Switch } from 'react-router-dom'
import { withRouter } from 'react-router'

import CommonRoute from '../routing/CommonRoute'
import CreateRetailer from '../views/CreateRetailer';

/*import { connect, selectors, actions } from '../../stores'*/

export class CreateRetailerRoute extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Switch>
        <CommonRoute
          component={CreateRetailer}
          exact={true}
          path={`${this.props.match.path}`}
        />
      </Switch>
    )
  }
}

CreateRetailerRoute.propTypes = {
  match: PropTypes.object,
};

export default withRouter(CreateRetailerRoute)